import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDBox } from '@facet-wealth/design';

function OnboardingPostOnboardingFirstMeetingConfirmation() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  if (!resource) return null;

  return (
    <FDBox>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDBox>
  );
}

export default OnboardingPostOnboardingFirstMeetingConfirmation;
